import React, { useState } from 'react';
import './GetStarted.css';
import { useNavigate, Navigate } from "react-router-dom";
import { FiHome } from "react-icons/fi";
import SalesPopup from '../components/SalesPopup';
import Signup from './Signup';
import LoginModal from './Login';
import XiLogo from '../components/ui/XiLogo';
import useTranslation from '../hooks/useTranslation';

export default function GetStarted() {
  const navigate = useNavigate();
  const [showSalesPopup, setShowSalesPopup] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { t } = useTranslation();

  // CRITICAL: Check if user is logged in - redirect immediately if logged in
  // Check synchronously before any rendering
  const userId = typeof window !== 'undefined' ? localStorage.getItem('neuro_user_id') : null;
  
  // If user is logged in, redirect immediately (don't render GetStarted page)
  if (userId) {
    return <Navigate to="/" replace />;
  }

  // FIX: Move roles array here so t is defined
const roles = [
  {
      key: 'Individual',
      title: t("Individual"), // Translate role
      desc: t("For personal mental wellness tracking and emotional support"), // Translate desc
      btn: t("Continue"), // Translate button
      icon: "/1.png",
    btnClass: "orange"
  },
  {
      key: 'Doctor',
      title: t("Doctor"),
      desc: t("Patient management, risk assessment & treatment tracking"),
      btn: t("Continue"),
      icon: "/doctor-icon.svg",
    btnClass: "blue"
  },
  {
      key: 'Hospital',
      title: t("Hospital"),
      desc: t("Access patient tools, predictions & insights"),
      btn: t("Continue"),
      icon: "/2.png",
    btnClass: "blue"
  },
  {
      key: 'Corporate',
      title: t("Corporate"),
      desc: t("Team wellness dashboard, performance & HR insights"),
      btn: t("Continue"),
    icon: "/7.png",
    btnClass: "orange"
  },
  {
      key: 'School / University',
      title: t("School / University"),
      desc: t("Student mental health ecosystem & dashboard"),
      btn: t("Continue"),
    icon: "/4.png",
    btnClass: "school"
  },
  {
      key: 'Sports Management',
      title: t("Sports Management"),
      desc: t("Emotional + cognitive tracking for athletes"),
      btn: t("Continue"),
    icon: "/6.png",
    btnClass: "orange"
  }
  ,
  {
      key: 'Take Care Agency',
      title: t("Take Care Agency"),
      desc: t("Agency dashboard for patient queues, sessions, and reporting"),
      btn: t("Continue"),
    icon: "/tca.png",
    btnClass: "blue"
  }
];

  const handleRoleClick = (roleKey) => {
    // School/University, Corporate, Hospital, and Doctor should open signup, not sales popup
    if (roleKey === 'School / University' || roleKey === 'Corporate' || roleKey === 'Hospital' || roleKey === 'Doctor' || roleKey === 'Take Care Agency') {
      setShowSignupModal(true);
      // store selected role for signup
      localStorage.setItem('neuro_selected_role', roleKey);
      return;
    }
    // Use the language-agnostic key for logic
    if ([
      'Sports Management'
    ].includes(roleKey)) {
      setShowSalesPopup(true);
    }
    if (roleKey === 'Individual') {
      setShowSignupModal(true);
      // store selected role for signup
      localStorage.setItem('neuro_selected_role', roleKey);
    }
  };

  // Handler to open login modal from signup
  const handleShowLogin = () => {
    setShowSignupModal(false);
    setShowLoginModal(true);
  };

  // Handler for login success (redirect to home)
  const handleLoginSuccess = () => {
    navigate('/');
  };

  return (
    <div className="getstarted-bg">
      <nav className="getstarted-nav">
        <span className="logo">
          <XiLogo size="md" />
        </span>
        <button
          type="button"
          className="getstarted-close-btn"
              aria-label={t('Go to home page')}
          onClick={() => navigate("/")}
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          <FiHome className="getstarted-home-icon" />
        </button>
      </nav>
      <header className="getstarted-header">
        <h1>{t('Join Xi - Choose')}<br />{t('Your Role to Get Started')}</h1>
        <p>
          {t('Sign up as an individual or as part of an organization to unlock')} <br />
          {t('tailored mental wellness tools and AI-powered features')}
        </p>
      </header>
      <section className="roles-row">
        {roles.map(role => (
          <div className="role-card" key={role.key}>
            <div className="role-icon">
              <img src={role.icon} alt={role.title} />
            </div>
            <h2>{role.title}</h2>
            <p>{role.desc}</p>
            <button
              onClick={() => handleRoleClick(role.key)}
              className={`continue-btn ${role.btnClass}`}>
              {role.btn}
            </button>
          </div>
        ))}
      </section>
      {showSalesPopup && <SalesPopup onClose={() => setShowSalesPopup(false)} />}
      {showSignupModal && (
        <>
          <div className="signup-modal-bg" onClick={e => { if (e.target.classList.contains('signup-modal-bg')) setShowSignupModal(false); }}>
            <div className="signup-modal-center-wrapper">
              <Signup onBack={() => setShowSignupModal(false)} onShowLogin={handleShowLogin} />
            </div>
          </div>
        </>
      )}
      <LoginModal open={showLoginModal} onClose={() => setShowLoginModal(false)} onLoginSuccess={handleLoginSuccess} />
    </div>
  );
}
